import {
  Icons,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Stack,
} from '@cast/design-system';

import { HelmSvg, TerraformSvg } from 'assets/svg';

import { InstallationMethod } from '../../types';

const INSTALLATION_METHOD_OPTIONS = [
  { Icon: <Icons.Code />, value: 'script', label: 'Script' },
  {
    Icon: (
      <HelmSvg
        width={14}
        height={14}
        css={{ '--icon-color': 'currentColor' }}
      />
    ),
    value: 'helm',
    label: 'Helm',
  },
  {
    Icon: (
      <TerraformSvg
        width={14}
        height={14}
        css={{ '--icon-color': 'currentColor' }}
      />
    ),
    value: 'terraform',
    label: 'Terraform',
  },
] as const;

type InstallationMethodToggleProps = {
  value: InstallationMethod;
  onChange: (value: InstallationMethod) => void;
};

export const InstallationMethodToggle = ({
  value,
  onChange,
}: InstallationMethodToggleProps) => {
  return (
    <Stack direction="row" gap={16} alignItems="center" mb={8}>
      <Typography variant="h6">Connect with:</Typography>
      <ToggleButtonGroup
        size="sm"
        value={value}
        exclusive
        onChange={(_event, newValue: InstallationMethod) => {
          onChange(newValue);
        }}
        testId="installation-method-toggle"
      >
        {INSTALLATION_METHOD_OPTIONS.map((option) => (
          <ToggleButton
            key={option.value}
            icon={option.Icon}
            value={option.value}
            text={option.label}
            testId={`installation-method-${option.value}`}
          />
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
};
